<template>
  <footer class="container-fluid w-100 p-2 bg-dark">
    <div class="row">
      <div class="col-2 align-middle">
        <router-link
          :to="{ name: 'Home', params: { }}"
          class="navbar-brand"
        >
          <!-- <img class="" height="80" alt="BMG Logo" src="../assets/BMG-Full-Logo-3Color-BlueBack.png" > -->
          <svg
            height="80"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 200 116.09"
          >
            <title>BMG</title>
            <g
              id="Layer_2"
              data-name="Layer 2"
            >
              <g
                id="Layer_1-2"
                data-name="Layer 1"
              >
                <g id="Logo_Vert_Full">
                  <g id="BMG_Logo_Medical_Group">
                    <path
                      id="Name_Group_P"
                      class="bmg-logo-svg-1"
                      d="M191.77,104.9h4.11c2.49,0,4.12,1.32,4.12,3.49v0c0,2.37-2,3.6-4.32,3.6H193v3.88h-1.24Zm4,6c1.82,0,3-1,3-2.42v0c0-1.57-1.18-2.39-3-2.39H193v4.84Z"
                    />
                    <path
                      id="Name_Group_U"
                      class="bmg-logo-svg-1"
                      d="M174.26,111.3v-6.4h1.24v6.32c0,2.37,1.28,3.71,3.37,3.71s3.31-1.23,3.31-3.63v-6.4h1.25v6.3c0,3.21-1.84,4.88-4.59,4.88S174.26,114.41,174.26,111.3Z"
                    />
                    <path
                      id="Name_Group_O"
                      class="bmg-logo-svg-1"
                      d="M155.32,110.43v0a5.58,5.58,0,0,1,5.63-5.69,5.52,5.52,0,0,1,5.59,5.66v0a5.61,5.61,0,1,1-11.22,0Zm9.94,0v0a4.38,4.38,0,0,0-4.34-4.54,4.32,4.32,0,0,0-4.31,4.51v0a4.38,4.38,0,0,0,4.34,4.54A4.33,4.33,0,0,0,165.26,110.43Z"
                    />
                    <path
                      id="Name_Group_R"
                      class="bmg-logo-svg-1"
                      d="M139.4,104.9h4.73a4.33,4.33,0,0,1,3.13,1.1,3,3,0,0,1,.85,2.17v0a3.23,3.23,0,0,1-3,3.21l3.38,4.49H147l-3.19-4.27h-3.14v4.27H139.4Zm4.62,5.61c1.65,0,2.83-.85,2.83-2.26v0c0-1.35-1-2.17-2.81-2.17h-3.39v4.46Z"
                    />
                    <path
                      id="Name_Group_G"
                      class="bmg-logo-svg-1"
                      d="M121.22,110.43v0a5.52,5.52,0,0,1,5.52-5.69,5.83,5.83,0,0,1,4.1,1.46l-.8,1a4.69,4.69,0,0,0-3.35-1.26,4.3,4.3,0,0,0-4.18,4.51v0a4.24,4.24,0,0,0,4.35,4.57,5.16,5.16,0,0,0,3.18-1.1v-2.73h-3.35V110h4.54v4.39a6.67,6.67,0,0,1-4.42,1.68A5.39,5.39,0,0,1,121.22,110.43Z"
                    />
                    <path
                      id="Name_Medical_L"
                      class="bmg-logo-svg-1"
                      d="M96.36,104.9H97.6v9.86h6.19v1.14H96.36Z"
                    />
                    <path
                      id="Name_Medical_A"
                      class="bmg-logo-svg-1"
                      d="M82.86,104.82H84l5,11.08H87.7L86.41,113h-6l-1.3,2.91H77.85Zm3.06,7-2.49-5.59-2.52,5.59Z"
                    />
                    <path
                      id="Name_Medical_C"
                      class="bmg-logo-svg-1"
                      d="M61.4,110.43v0A5.54,5.54,0,0,1,67,104.71a5.71,5.71,0,0,1,4.29,1.75l-.85.91a4.78,4.78,0,0,0-3.46-1.51,4.31,4.31,0,0,0-4.25,4.51v0a4.33,4.33,0,0,0,4.25,4.54,4.82,4.82,0,0,0,3.56-1.58l.81.8a5.72,5.72,0,0,1-4.4,1.93A5.49,5.49,0,0,1,61.4,110.43Z"
                    />
                    <path
                      id="Name_Medical_I"
                      class="bmg-logo-svg-1"
                      d="M52.21,104.9h1.24v11H52.21Z"
                    />
                    <path
                      id="Name_Medical_D"
                      class="bmg-logo-svg-1"
                      d="M34.59,104.9h3.82c3.46,0,5.85,2.37,5.85,5.47v0a5.51,5.51,0,0,1-5.85,5.5H34.59Zm1.24,1.15v8.71h2.58A4.27,4.27,0,0,0,43,110.43v0a4.29,4.29,0,0,0-4.56-4.35Z"
                    />
                    <path
                      id="Name_Medical_E"
                      class="bmg-logo-svg-1"
                      d="M19,104.9h8V106H20.24v3.76h6v1.13h-6v3.85H27v1.13H19Z"
                    />
                    <path
                      id="Name_Medical_M"
                      class="bmg-logo-svg-1"
                      d="M0,104.9H1.26l4,6,4-6h1.26v11H9.29V107l-4,5.89H5.22l-4-5.87v8.89H0Z"
                    />
                  </g>
                  <!-- <g id="BMG_Logo_Dark_Bridging">
                    <path id="Name_Bridging_Dark_G2" class="bmg-logo-svg-2" d="M172.67,81.85v-.08a14.25,14.25,0,0,1,14.56-14.36c5,0,8,1.35,10.91,3.81l-3.85,4.64A10.21,10.21,0,0,0,187,73c-4.44,0-8,3.93-8,8.65v.08c0,5.08,3.49,8.81,8.41,8.81a9.76,9.76,0,0,0,5.75-1.67v-4h-6.15V79.67h12.06V91.73a18,18,0,0,1-11.86,4.4C178.62,96.13,172.67,90.06,172.67,81.85Z"/>
                    <path id="Name_Bridging_Dark_N" class="bmg-logo-svg-2" d="M143.08,67.88h5.64l13,17.1V67.88h6V95.65h-5.2L149.11,78V95.65h-6Z"/>
                    <path id="Name_Bridging_Dark_I2" class="bmg-logo-svg-2" d="M130.6,67.88h6.11V95.65H130.6Z"/>
                    <path id="Name_Bridging_Dark_G" class="bmg-logo-svg-2" d="M98.3,81.85v-.08a14.25,14.25,0,0,1,14.56-14.36c5,0,8,1.35,10.91,3.81l-3.85,4.64A10.21,10.21,0,0,0,112.66,73c-4.44,0-8,3.93-8,8.65v.08c0,5.08,3.49,8.81,8.41,8.81a9.76,9.76,0,0,0,5.75-1.67v-4H112.7V79.67h12.06V91.73a18,18,0,0,1-11.86,4.4C104.25,96.13,98.3,90.06,98.3,81.85Z"/>
                    <path id="Name_Bridging_Dark_D" class="bmg-logo-svg-2" d="M69.3,67.88H80.13c8.73,0,14.76,6,14.76,13.81v.08c0,7.81-6,13.88-14.76,13.88H69.3Zm6.11,5.52V90.14h4.72c5,0,8.37-3.37,8.37-8.29v-.08a8,8,0,0,0-8.37-8.37Z"/>
                    <path id="Name_Bridging_Dark_I" class="bmg-logo-svg-2" d="M56.81,67.88h6.11V95.65H56.81Z"/>
                    <path id="Name_Bridging_Dark_R" class="bmg-logo-svg-2" d="M28.42,67.88H41.11c3.53,0,6.27,1,8.1,2.82a8.75,8.75,0,0,1,2.38,6.35v.08a8.63,8.63,0,0,1-6,8.61l6.79,9.91H45.28l-6-8.88h-4.8v8.88H28.42Zm12.3,13.49c3,0,4.68-1.58,4.68-3.93v-.07c0-2.62-1.83-4-4.8-4H34.53v8Z"/>
                    <path id="Name_Bridging_Dark_B" class="bmg-logo-svg-2" d="M0,67.88H12.89c3.18,0,5.68.88,7.26,2.46a6.38,6.38,0,0,1,1.91,4.72v.08a6.46,6.46,0,0,1-3.65,6c3.21,1.23,5.2,3.1,5.2,6.83V88c0,5.08-4.13,7.61-10.4,7.61H0ZM16,76.1c0-1.83-1.43-2.86-4-2.86H6v5.87h5.63c2.7,0,4.41-.87,4.41-2.93Zm-3,8.09H6V90.3h7.26c2.7,0,4.33-1,4.33-3V87.2C17.54,85.34,16.15,84.19,13,84.19Z"/>
                  </g> -->
                  <g id="BMG_Logo_White_Bridging">
                    <path
                      id="Name_Bridging_White_G2"
                      class="bmg-logo-svg-3"
                      d="M172.77,81.83v-.08a14.26,14.26,0,0,1,14.56-14.36c5,0,8,1.35,10.91,3.81l-3.85,4.64A10.25,10.25,0,0,0,187.13,73c-4.45,0-8,3.93-8,8.65v.08c0,5.08,3.49,8.81,8.41,8.81a9.77,9.77,0,0,0,5.76-1.67v-4h-6.15V79.65h12.06V91.71a18,18,0,0,1-11.86,4.4C178.72,96.11,172.77,90,172.77,81.83Z"
                    />
                    <path
                      id="Name_Bridging_White_N"
                      class="bmg-logo-svg-3"
                      d="M143.18,67.87h5.64l13,17.1V67.87h6V95.64h-5.2L149.21,78V95.64h-6Z"
                    />
                    <path
                      id="Name_Bridging_White_I2"
                      class="bmg-logo-svg-3"
                      d="M130.69,67.87h6.11V95.64h-6.11Z"
                    />
                    <path
                      id="Name_Bridging_White_G"
                      class="bmg-logo-svg-3"
                      d="M98.4,81.83v-.08A14.26,14.26,0,0,1,113,67.39c5,0,8,1.35,10.91,3.81L120,75.84A10.25,10.25,0,0,0,112.76,73c-4.44,0-8,3.93-8,8.65v.08c0,5.08,3.5,8.81,8.42,8.81A9.76,9.76,0,0,0,119,88.89v-4H112.8V79.65h12.06V91.71A18,18,0,0,1,113,96.11C104.35,96.11,98.4,90,98.4,81.83Z"
                    />
                    <path
                      id="Name_Bridging_White_D"
                      class="bmg-logo-svg-3"
                      d="M69.4,67.87H80.23c8.73,0,14.76,6,14.76,13.8v.08c0,7.82-6,13.89-14.76,13.89H69.4Zm6.11,5.51V90.12h4.72c5,0,8.37-3.37,8.37-8.29v-.08a8,8,0,0,0-8.37-8.37Z"
                    />
                    <path
                      id="Name_Bridging_White_I"
                      class="bmg-logo-svg-3"
                      d="M56.91,67.87H63V95.64H56.91Z"
                    />
                    <path
                      id="Name_Bridging_White_R"
                      class="bmg-logo-svg-3"
                      d="M28.52,67.87H41.21c3.53,0,6.27,1,8.09,2.81A8.71,8.71,0,0,1,51.68,77v.08a8.63,8.63,0,0,1-6,8.61l6.79,9.92H45.38l-6-8.89H34.62v8.89h-6.1ZM40.81,81.35c3,0,4.69-1.58,4.69-3.92v-.08c0-2.62-1.83-4-4.81-4H34.62v8Z"
                    />
                    <path
                      id="Name_Bridging_White_B"
                      class="bmg-logo-svg-3"
                      d="M.1,67.87H13c3.18,0,5.68.87,7.26,2.46a6.36,6.36,0,0,1,1.91,4.72v.08a6.47,6.47,0,0,1-3.65,6c3.21,1.23,5.19,3.09,5.19,6.82V88c0,5.08-4.12,7.62-10.39,7.62H.1Zm16,8.21c0-1.83-1.43-2.86-4-2.86h-6v5.87h5.63c2.7,0,4.41-.87,4.41-2.93Zm-3,8.09H6.05v6.11h7.26c2.7,0,4.32-1,4.32-3v-.08C17.63,85.32,16.25,84.17,13.11,84.17Z"
                    />
                  </g>
                  <g id="BMG_Logo_Icon">
                    <path
                      id="Right_1"
                      class="bmg-logo-svg-4"
                      d="M106.44,0h-2.22c0,18.8,8.58,36.19,21.85,44.31V41.67C114.1,33.66,106.44,17.49,106.44,0Z"
                    />
                    <path
                      id="Right_2"
                      class="bmg-logo-svg-4"
                      d="M101.11,0H98.89c0,22.21,10.67,42,27.18,50.39V47.87C110.87,39.55,101.11,20.93,101.11,0Z"
                    />
                    <path
                      id="Right_3"
                      class="bmg-logo-svg-4"
                      d="M95.78,0H93.56c0,25.19,13.06,47.77,32.51,56.27V53.82C107.91,45.38,95.78,23.93,95.78,0Z"
                    />
                    <path
                      id="Left_1"
                      class="bmg-logo-svg-1"
                      d="M93.56,0h2.22c0,18.8-8.58,36.19-21.85,44.31V41.67C85.9,33.66,93.56,17.49,93.56,0Z"
                    />
                    <path
                      id="Left_2"
                      class="bmg-logo-svg-1"
                      d="M98.89,0h2.22c0,22.21-10.67,42-27.18,50.39V47.87C89.13,39.55,98.89,20.93,98.89,0Z"
                    />
                    <path
                      id="Left_3"
                      class="bmg-logo-svg-1"
                      d="M104.22,0h2.22c0,25.19-13.06,47.77-32.51,56.27V53.82C92.09,45.38,104.22,23.93,104.22,0Z"
                    />
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </router-link>
      </div>
      <div class="col-md-3 centered-on-page">
        <!-- <div v-if="showButtons" class="centered-on-page h-100">
          <span class="text-white text-center">See BMG's profile at <a class="externalLinksGoogleTracking" href="https://www.redcrow.com/home/discover-profile.html?id=1000048352049" target="_blank">Redcrow.com</a><br>(Emerging Medical Supernovas)</span>
        </div> -->
        <div
          v-if="showButtons"
          class="centered-on-page h-100"
        >
          <span class="text-white text-center">See BMG's profile at <a
            class="externalLinksGoogleTracking"
            href="https://www.redcrow.com/live/company-profile.html?id=1000048352049"
            target="_blank"
          >Redcrow.com</a><br>(Emerging Medical Supernovas)<br>(password: BMG)</span>
        </div>
      </div>
      <div class="col-md-3 centered-on-page">
        <div
          v-if="showButtons"
          class="centered-on-page h-100"
        >
          <span class="text-white text-center">See BMG's profile at <a
            class="externalLinksGoogleTracking"
            href="https://innovationmatch.ama-assn.org/companies/78508"
            target="_blank"
          >AMA.org</a><br>(American Medical Association)</span>
        </div>
      </div>
      <div class="col-md-3 centered-on-page text-center">
        <div class="align-middle h-100">
          <a
            class=""
            href="mailto:info@bridgingmedical.com"
          >info@bridgingmedical.com</a><br>
          <a
            class="text-white"
            href="tel:+1(801)380-2376"
          >+1 (801) 380-2376</a><br>
          <span class="text-white">©2019 by Bridging Medical Group, LLC..</span>
        </div>
      </div>
    </div>
    <div class="centered-on-page">
      <div class="text-centered text-white w-70">
        <em>
          <small>
            While every effort has been made by BMG to assure the content presented on this website is accurate
            representing current medical and engineering fact, and expectations of future results of research and
            development, it cannot be guaranteed. Further, this website is not an offer to sell nor a solicitation to
            buy securities in Bridging Medical Group, LLC.
          </small>
        </em>
      </div>
    </div>
  </footer>
</template>

<div class="container-fluid m-3 centered-on-page">
  <div class="my-3">
  </div>
  <div class="my-3">
  </div>
</div>

<script>

export default {
  name: 'BmgFooter',
  components: {},
  computed: {
    showButtons () {
      return '/login' !== this.$route.path
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
